<select class="input minimal" (change)="addValetStationFilter($event)" [value]="SelectedValetStation">
  <option value="" style="color:gray">No Valet Station Filter</option>
  @for (i of ValetStations; track i) {
    <option [selected]="ValetStationSelected(i)" [value]="i.Id.toString()">{{i.Name}}
    </option>
  }
</select>
